// extracted by mini-css-extract-plugin
export default {"key-takeaways-footer":"KeyTakeaways_key-takeaways-footer__-5eAR","active":"KeyTakeaways_active__ZJehC"};